import type { SpacingToken } from '@/theme/tokens';

export type DialogRhythm = {
  headerGap: SpacingToken;
  contentOffset: SpacingToken;
  contentGap: SpacingToken;
  footerGap: SpacingToken;
  actionsGap: SpacingToken;
  bodyGap: SpacingToken;
  sectionGap: SpacingToken;
  sectionContentGap: SpacingToken;
  workflowGap: SpacingToken;
};

export const dialogRhythm = {
  headerGap: 'sm',
  contentOffset: 'lg',
  contentGap: 'md',
  footerGap: 'md',
  actionsGap: 'md',
  bodyGap: 'md',
  sectionGap: 'lg',
  sectionContentGap: 'md',
  workflowGap: 'lg',
} satisfies DialogRhythm;
